class TranslationAnswer {
	constructor() {
		this.code = '';
		this.name = '';
	}
}

export default TranslationAnswer;
